const TURKISH_MONTH_NAMES = [
  'Ocak',
  'Şubat',
  'Mart',
  'Nisan',
  'Mayıs',
  'Haziran',
  'Temmuz',
  'Ağustos',
  'Eylül',
  'Ekim',
  'Kasım',
  'Aralık',
] as const;

/** Ay değeri "1"…"12", etiket Türkçe ay adı */
export const BIRTH_MONTH_LABELS: { value: string; label: string }[] = TURKISH_MONTH_NAMES.map(
  (name, i) => ({
    value: String(i + 1),
    label: name,
  }),
);

/** Mevcut yıl dahil, geriye 10 yıl (toplam 11 yıl). */
export function birthYearOptions(): string[] {
  const y = new Date().getFullYear();
  const out: string[] = [];
  for (let i = 10; i >= 0; i -= 1) {
    out.push(String(y - i));
  }
  return out;
}
